import { Button } from "@/components/ui/button";
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { LuPaperclip } from "react-icons/lu";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useAttachments } from "./AttachmentContext";

export default function AttachmentUploadButton({ className = "" }) {
    const { 
        isUploading, 
        uploadProgress, 
        triggerFileUpload, 
        handleFileUpload, 
        fileInputRef 
    } = useAttachments();

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length > 0) {
            handleFileUpload(files);
            event.target.value = ''; // Reset input
        }
    };

    return (
        <TooltipProvider delayDuration={0}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className={`h-7 w-7 ${className}`}
                        onClick={triggerFileUpload}
                        disabled={isUploading}
                    >
                        {isUploading ? (
                            <div className="flex items-center gap-1">
                                <AiOutlineLoading3Quarters className="h-3.5 w-3.5 animate-spin" />
                                <span className="text-xs ml-1">{uploadProgress}%</span>
                            </div>
                        ) : (
                            <LuPaperclip className="h-3.5 w-3.5" />
                        )}
                        <input
                            type="file"
                            ref={fileInputRef}
                            className="hidden"
                            onChange={handleFileChange}
                            disabled={isUploading}
                            multiple
                        />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    {isUploading ? `Uploading... ${uploadProgress}%` : 'Upload attachments'}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
} 